export default "__VITE_ASSET__CirchRPk__"